/**
 * Load all PMW functions
 *
 * Ignore event listeners. They need to be loaded after
 * we made sure that jQuery has been loaded.
 */

require("./functions")

/**
 * Load consent management module as a chunk
 * @returns {Promise<void>}
 */
window.pmw.loadConsentModule = async () => {
	// Fetch both chunks in parallel. Awaiting them one after the other cost
	// a second network round trip before any pixel could load.
	const [consentModule, apiModule] = await Promise.all([
		import(/* webpackChunkName: "consent-management" */ "./consent/consent.mjs"),
		import(/* webpackChunkName: "consent-api" */ "./consent/api.mjs"),
	])

	// Only expose pmw.consent once both chunks have loaded. If pmw.consent is
	// assigned between the two imports and the api chunk then fails to load,
	// consumers (and tests) can observe a half-initialized consent module
	// without .api before main() swaps in the deny-by-default fallback.
	window.pmw.consent     = consentModule
	window.pmw.consent.api = apiModule

	return consentModule
}

window.pmw = window.pmw || {}
window.pmw.console = require("./console.mjs")

// Load cross-tab session sync module
const crossTabSync         = require("./cross-tab-sync.mjs")
window.pmw.crossTabSync    = crossTabSync

require("./ip_services")

// #if process.env.TIER === 'premium'
// if (pmw.canLoadPremiumFeatures()) {
// 	require("./functions_premium")
// }
// #endif
